// Shared by the browser and scheduled Firebase delivery.
export function zonedDateTime(date, time = '09:00', timeZone = 'UTC') {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(date || '');
  const clock = /^(\d{2}):(\d{2})$/.exec(time || '');
  if (!match || !clock || +clock[1] > 23 || +clock[2] > 59) return NaN;
  const target = Date.UTC(+match[1], +match[2] - 1, +match[3], +clock[1], +clock[2]);
  let instant = target;
  try {
    const formatter = new Intl.DateTimeFormat('en-GB', { timeZone, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
    for (let attempt = 0; attempt < 3; attempt++) {
      const parts = Object.fromEntries(formatter.formatToParts(new Date(instant)).map(p => [p.type, p.value]));
      const observed = Date.UTC(+parts.year, +parts.month - 1, +parts.day, +parts.hour, +parts.minute);
      if (observed === target) return instant;
      instant += target - observed;
    }
  } catch { return NaN; }
  return NaN;
}

export function reminderDueAt(reminder, defaultZone = 'UTC') {
  if (reminder.snoozed_until) return Date.parse(reminder.snoozed_until);
  if (reminder.due_at) return Date.parse(reminder.due_at);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(reminder.target_date || '')) return NaN;
  const days = Number(reminder.reminder_days_before ?? 0);
  if (!Number.isInteger(days) || days < 0 || days > 365) return NaN;
  const date = new Date(`${reminder.target_date}T00:00:00Z`);
  if (!Number.isFinite(date.getTime()) || date.toISOString().slice(0, 10) !== reminder.target_date) return NaN;
  date.setUTCDate(date.getUTCDate() - days);
  return zonedDateTime(date.toISOString().slice(0, 10), reminder.reminder_time || '09:00', reminder.time_zone || defaultZone);
}

export function reminderIsDue(reminder, now = Date.now(), defaultZone = 'UTC') {
  return ['active', 'snoozed'].includes(reminder.status || 'active') && !reminder.is_sent && reminderDueAt(reminder, defaultZone) <= now;
}
